import { Component, AfterViewInit, OnInit } from '@angular/core';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import * as GeotabApi from 'mg-api-js';
import { GeotabService } from 'src/app/services/geotab.service';
import { ModalService } from 'src/app/services/modal.service';
import { environment } from 'src/environments/environment';
import { forkJoin, of, timer } from 'rxjs';
import { catchError } from 'rxjs/operators';

interface RouteConfig {
  id: string;
  label: string;
  color: string;
  url: string;
  checked: boolean;
}

interface RouteLayer {
  routeGroup: L.LayerGroup;
  stopCluster: L.MarkerClusterGroup;
  stopUnclustered: L.LayerGroup;
  stopMarkers: L.Marker[];
  routeLine: L.GeoJSON | null;
}

interface Vehicle {
  id: any;
  driver: string;
  status: string;
  speed: number;
  currentLat: number;
  currentLng: number;
  bearing: number;
  marker: L.Marker | null;
  routeId: string | null;
  eta: string;
  prevLat?: number;
  prevLng?: number;
  targetLat?: number;
  targetLng?: number;
  animationStartTime?: number;
  animationDuration?: number;
  isDriving?: boolean;

  _lastStatusClass?: string;
  _lastDrivingState?: boolean;
  busDetails?: {
    plateNumber?: string;
    driverName?: string;
    routeName?: string;
    vehicleStatus?: string;
    currentStopName?: string;
    [key: string]: any;
  };
}

@Component({
  selector: 'app-map-tracker',
  templateUrl: './map-tracker.component.html',
  styleUrls: ['./map-tracker.component.scss']
})
export class MapTrackerComponent implements OnInit, AfterViewInit {
  map!: L.Map;
  controlsEl!: HTMLElement;

  creds: any;
  apiCalls: any[] = [];
  selectedUnit: any[] = [];
  pollInterval: any;

  routes: RouteConfig[] = [

    { id: 'route2', label: 'BATASAN - VGC', color: '#FF3CAC', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/BATASAN - VGC.geojson', checked: true },
    { id: 'route4', label: 'PITX - MOA - U Belt - VGC', color: '#CDB4FF', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/PITX - MOA - U Belt - VGC.geojson', checked: true },
    { id: 'route8', label: 'VGC - BATASAN', color: '#FFD166', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/VGC - BATASAN.geojson', checked: true },
    { id: 'route9', label: 'VGC - U Belt - MOA - PITX', color: '#FF3CAC', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/VGC - U Belt - MOA - PITX.geojson', checked: true },
    { id: 'route10', label: 'McKinley Exchange cor EDSA McKinley to McKinley Exchange', color: '#8c00ff', url: 'assets/geojson/McKinley Exchange cor EDSA McKinley to McKinley Exchange.geojson', checked: true },
    { id: 'route11', label: 'Market-Market to Market-Market', color: '#00ffc6', url: 'assets/geojson/Market-Market to Market-Market.geojson', checked: true },

    { id: 'route12', label: 'McKinley Exchange to WFC', color: '#008000', url: 'assets/geojson/McKinley Exchange to WFC.geojson', checked: true },
    { id: 'route13', label: 'PITX to WFC', color: '#ffdf05', url: 'assets/geojson/PITX to WFC.geojson', checked: true },
    { id: 'route14', label: 'SM Aura Tower to WFC', color: '#2d05ff', url: 'assets/geojson/SM Aura Tower to WFC.geojson', checked: true },
    { id: 'route15', label: 'WFC to McKinley Exchange', color: '#ff0505', url: 'assets/geojson/WFC to McKinley Exchange.geojson', checked: true },
    { id: 'route16', label: 'WFC to PITX', color: '#05ff7c', url: 'assets/geojson/WFC to PITX.geojson', checked: true },
    { id: 'route17', label: 'WFC to SM Aura Tower', color: '#919dff', url: 'assets/geojson/WFC to SM Aura Tower.geojson', checked: true },

    // { id: 'route1', label: 'BATASAN - VGC - BATASAN', color: '#7DFFAF', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/BATASAN - VGC - BATASAN.geojson', checked: true },
    // { id: 'route3', label: 'Batasan-Congressional-VGC', color: '#4CC9F0', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/Batasan-Congressional-VGC.geojson', checked: true },
    // { id: 'route5', label: 'PITX-MOA-UBelt-VGC', color: '#FF9F1C', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/PITX-MOA-UBelt-VGC.geojson', checked: true },
    // { id: 'route6', label: 'VGC - BATASAN - VGC', color: '#FF6B6B', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/VGC - BATASAN - VGC.geojson', checked: true },
    // { id: 'route10', label: 'VGC-Congressional-Batasan', color: '#7DFFAF', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/VGC-Congressional-Batasan.geojson', checked: true },
    // { id: 'route11', label: 'VGC-UBelt-MOA-PITX', color: '#FF3CAC', url: 'https://get-pass-assets.s3.ap-southeast-1.amazonaws.com/route_geojson/VGC-UBelt-MOA-PITX.geojson', checked: true },
  ];

  routeLayers: Record<string, RouteLayer> = {};
  activeRoute: string | null = null;

  vehiclesData: Vehicle[] = [];
  vehicleMarkers!: L.LayerGroup;

  STATUS_COLORS: Record<string, string> = {
    'ON_TIME': 'status-green',
    'DELAY': 'status-yellow',
    'INCIDENT': 'status-red'
  };

  units: any = [
    { name: 'UNIT 18', deviceId: 'b268' },
    { name: 'UNIT 18', deviceId: 'b266' },
    { name: 'UNIT 18', deviceId: 'b265' },
    { name: 'UNIT 18', deviceId: 'b26B' },
    { name: 'UNIT 18', deviceId: 'b26E' },
    { name: 'UNIT 18', deviceId: 'b26C' },
    { name: 'UNIT 18', deviceId: 'b26D' },
    { name: 'UNIT 18', deviceId: 'b267' },
  ]

  activeStop: { name: string; lat: number; lng: number } | null = null;

  activeStops: any[] = [];
  currentStop: any;

  constructor(
    private geotabService: GeotabService,
    private modalService: ModalService
  ) { }

  async ngOnInit(): Promise<void> {
    // const unit = { name: 'UNIT 18', deviceId: 'b268' };
    // this.selectedUnit.push(unit);

    if (this.units.length > 0) {
      this.units.forEach(u => {
        this.apiCalls.push(['Get', {
          typeName: 'DeviceStatusInfo',
          search: { deviceSearch: { id: u.deviceId } }
        }]);
      });
    }

    const authentication = {
      credentials: {
        database: environment.database,
        userName: environment.userName,
        password: environment.password
      }
    };
    const api = new GeotabApi(authentication);

    try {
      const response = await api.authenticate();
      this.creds = response.credentials;
      if (this.creds) {
        this.pollForData();
        this.pollInterval = setInterval(() => this.pollForData(), 10000);
      }
    } catch (error) {
      console.error('Authentication error', error);
    }
  }

  ngAfterViewInit(): void {
    this.initMap();
    this.loadRoutes();
  }

  private initMap() {
    this.map = L.map('map').setView([14.5995, 120.9842], 12);
    L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(this.map);
    this.controlsEl = document.getElementById('controls')!;
    this.vehicleMarkers = L.layerGroup().addTo(this.map);

    this.map.on('move zoom', () => {
      if (this.activeStop) {
        const point = this.map.latLngToContainerPoint([this.activeStop.lat, this.activeStop.lng]);
        const modalEl = document.getElementById('stop-modal');
        if (modalEl) {
          modalEl.style.left = `${point.x}px`;
          modalEl.style.top = `${point.y}px`;
        }
      }

      const zoom = this.map.getZoom();
      const scale = this.getMarkerScale(zoom);
      const elements = document.querySelectorAll('.vehicle-icon-base');
      elements.forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.transform = `scale(${scale})`;
          el.style.transformOrigin = 'center center';
        }
      });

    });
  }

  private pollForData() {
    if (!this.creds) return;

    const credentials = {
      database: this.creds.database,
      userName: this.creds.userName,
      sessionId: this.creds.sessionId
    };
    const path = 'my.geotab.com';
    const api = new GeotabApi({ credentials, path });

    api.multiCall(this.apiCalls)
      .then((result: any[]) => {
        // Update vehicle info from Geotab
        result.forEach((res: any[]) => {
          const vData = res[0];
          let vehicle = this.vehiclesData.find(v => v.id === vData.device.id);

          if (!vehicle) {
            vehicle = {
              id: vData.device.id,
              driver: vData.driver || 'Unknown',
              status: vData.isDeviceCommunicating ? 'ON_TIME' : 'DELAY',
              speed: vData.speed,
              currentLat: vData.latitude,
              currentLng: vData.longitude,
              bearing: vData.bearing,
              marker: null,
              routeId: null,
              eta: '-',
              isDriving: vData?.isDriving,
              busDetails: null
            };
            this.vehiclesData.push(vehicle);
          }

          // Update animation and position
          vehicle.prevLat = vehicle.currentLat;
          vehicle.prevLng = vehicle.currentLng;
          vehicle.targetLat = vData.latitude;
          vehicle.targetLng = vData.longitude;
          vehicle.bearing = vData.bearing;
          vehicle.animationStartTime = performance.now();
          vehicle.animationDuration = 4000;
          vehicle.isDriving = vData.isDriving;
          vehicle.status = vData.isDeviceCommunicating ? 'ON_TIME' : 'DELAY';
          vehicle.speed = vData.speed;
        });

        // Animate vehicle markers
        this.animateVehicles();

        // Split vehicles into batches of 3
        const batchSize = 3;
        const batches: any[][] = [];
        for (let i = 0; i < this.vehiclesData.length; i += batchSize) {
          batches.push(this.vehiclesData.slice(i, i + batchSize));
        }

        // Recursive function to process batches every 15s
        const processBatch = (batchIndex: number) => {
          if (batchIndex >= batches.length) {
            return;
          }

          const batch = batches[batchIndex];
          const requests = batch.map(v =>
            this.geotabService.getBusDetails(v.id).pipe(
              catchError(err => {
                console.error(`Error fetching bus ${v.id}`, err);
                return of(null);
              })
            )
          );

          forkJoin(requests).subscribe({
            next: (responses: any[]) => {
              responses.forEach((res, i) => {
                if (res?.details) batch[i].busDetails = res.details;
              });

              // Update vehicle icons after bus details are fetched
              batch.forEach(v => {
                if (v.marker) {
                  const totalPassengers = v.busDetails?.activePassengers?.reduce(
                    (sum: number, p: any) => sum + (p?.quantity || 0),
                    0
                  ) || 0;

                  const isMoving = v.isDriving;
                  const icon = this.createVehicleIcon(v, v.status, isMoving, v.bearing || 0);
                  v.marker.setIcon(icon);
                }
              });

              timer(15000).subscribe(() => processBatch(batchIndex + 1));
            },
            error: err => {
              console.error('Batch error:', err);
              timer(15000).subscribe(() => processBatch(batchIndex + 1));
            }
          });
        };

        // Start first batch
        processBatch(0);
      })
      .catch(err => console.error('Geotab API error', err));
  }


  private animateVehicles() {
    const animate = (time: number) => {
      let anyMoving = false;

      this.vehiclesData.forEach((v) => {
        if (v.targetLat == null || v.targetLng == null) return;

        const elapsed = time - (v.animationStartTime || time);
        const duration = v.animationDuration || 1000;
        const t = Math.min(elapsed / duration, 1);
        if (t < 1) anyMoving = true;

        const prevLat = v.prevLat ?? v.currentLat;
        const prevLng = v.prevLng ?? v.currentLng;

        const newLat = (1 - t) * prevLat + t * v.targetLat;
        const newLng = (1 - t) * prevLng + t * v.targetLng;

        const distance = this.getDistance(v.currentLat, v.currentLng, newLat, newLng);
        const isMoving = distance > 0.00005;

        v.currentLat = newLat;
        v.currentLng = newLng;

        if (!v.marker) {
          const icon = this.createVehicleIcon(v, v.status, isMoving, v.bearing || 0);
          v.marker = L.marker([v.currentLat, v.currentLng], { icon }).addTo(this.vehicleMarkers);
          v.marker.on('click', () => this.onBusClick(v));
          v._lastStatusClass = v.status;
          v._lastDrivingState = isMoving;
        } else {
          v.marker.setLatLng([v.currentLat, v.currentLng]);
          const el = v.marker.getElement();
          if (el) {
            const img = el.querySelector('img');
            if (img) img.style.transform = `rotate(${v.bearing || 0}deg)`;
          }
          if (v._lastDrivingState !== isMoving) {
            const newIcon = this.createVehicleIcon(v, v.status, isMoving, v.bearing || 0);
            v.marker.setIcon(newIcon);
            v._lastDrivingState = isMoving;
          }
        }
      });

      if (anyMoving) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }

  private createVehicleIcon(
    vehicle: any,
    statusClass: string,
    isMoving: boolean,
    bearing: number
  ) {
    let iconUrl: string;

    const hasPassengers = vehicle.busDetails?.activePassengers?.length > 0;

    if (hasPassengers) {
      const totalPassengers = vehicle.busDetails.activePassengers.reduce(
        (sum: number, p: any) => sum + (p?.quantity || 0),
        0
      );

      if (isMoving) {
        if (totalPassengers <= 10) iconUrl = 'assets/icons/moving-green.svg';
        else if (totalPassengers <= 15) iconUrl = 'assets/icons/moving-orange.svg';
        else iconUrl = 'assets/icons/moving-red.svg';
      } else {
        if (totalPassengers <= 10) iconUrl = 'assets/icons/stop-green.svg';
        else if (totalPassengers <= 15) iconUrl = 'assets/icons/stop-orange.svg';
        else iconUrl = 'assets/icons/stop-red.svg';
      }
    } else {
      iconUrl = isMoving
        ? 'assets/icons/moving-green.svg'
        : 'assets/icons/stop-green.svg';
    }

    const showAlert = vehicle.vehicleDetails?.alert?.length > 0;

    const size = 40;
    const anchor = size / 2;

    return L.divIcon({
      html: `
        <div class="vehicle-icon-base ${statusClass}" style="
          width: ${size}px;
          height: ${size}px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        ">
          ${showAlert ? `<img src="assets/alert.svg" class="alert-bus">` : ''}

          <img src="${iconUrl}" alt="bus" style="
            width: 100%;
            height: 100%;
            transform: rotate(${bearing}deg);
            transition: transform 0.2s linear;
          " />
        </div>
      `,
      iconSize: [size, size],
      iconAnchor: [anchor, anchor],
      className: ''
    });
  }


  private getDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  private getMarkerScale(zoom: number): number {
    const minZoom = 10;
    const maxZoom = 18;
    const minScale = 0.55;
    const maxScale = 1.7;
    const z = Math.max(minZoom, Math.min(maxZoom, zoom));
    const scale = minScale + ((z - minZoom) / (maxZoom - minZoom)) * (maxScale - minScale);
    return Number(scale.toFixed(3));
  }

  private showVehicleDetails(vehicle: Vehicle) {
    const content = `
      <p><strong>Route:</strong> ${vehicle.routeId}</p>
      <p><strong>Driver:</strong> ${vehicle.driver}</p>
      <p><strong>Speed:</strong> ${vehicle.speed} km/h</p>
      <p><strong>ETA:</strong> ${vehicle.eta}</p>
      <p><strong>Coordinates:</strong> ${vehicle.currentLat.toFixed(4)}, ${vehicle.currentLng.toFixed(4)}</p>
    `;
    this.openModal(`Vehicle ID: ${vehicle.id}`, content);
  }

  private async loadRoutes() {
    for (const route of this.routes) {
      const stopCluster = (L as any).markerClusterGroup();
      const routeGroup = L.layerGroup();
      const stopMarkers: L.Marker[] = [];
      const stopUnclustered = L.layerGroup();
      this.routeLayers[route.id] = { routeGroup, stopCluster, stopUnclustered, stopMarkers, routeLine: null };

      const data = await (await fetch(route.url)).json();

      const routeLine = L.geoJSON(data, {
        filter: f => f.geometry.type === 'LineString',
        style: { color: route.color, weight: 4, opacity: 0.45 }
      }).addTo(routeGroup);
      this.routeLayers[route.id].routeLine = routeLine;

      this.setupRouteLineEvents(route.id, routeLine);

      let stopNumber = 1;
      L.geoJSON(data, {
        filter: f => f.geometry.type === 'Point',
        pointToLayer: (feature, latlng) => {
          const marker = L.marker(latlng, { icon: this.createDefaultStopIcon() });
          // marker.on('click', () => this.openModal(feature.properties?.name || `Stop ${stopNumber}`, `Coordinates: ${latlng.lat.toFixed(4)}, ${latlng.lng.toFixed(4)}`));
          marker.on('click', () => {
            this.showStopModal(latlng, feature.properties?.name || `Stop ${stopNumber}`);
          });
          marker.on('mouseover', () => this.highlightRouteFromStop(route.id));
          marker.on('mouseout', () => this.resetAllRoutesStyle());


          stopMarkers.push(marker);
          stopCluster.addLayer(marker);
          stopNumber++;
          return marker;
        }
      });

      if (route.checked) {
        routeGroup.addTo(this.map);
        stopCluster.addTo(this.map);
      }
    }
  }

  private setupRouteLineEvents(routeId: string, routeLine: L.GeoJSON) {
    routeLine.eachLayer(layer => {
      if (layer instanceof L.Polyline) {
        layer.on('mouseover', () => {
          if (this.activeRoute !== routeId) layer.setStyle({ weight: 6, opacity: 1 });
        });
        layer.on('mouseout', () => {
          if (this.activeRoute !== routeId) layer.setStyle({ weight: 4, opacity: 0.45 });
        });
        layer.on('click', () => this.focusRoute(routeId));
        (layer as any).getElement?.()?.style?.setProperty('cursor', 'pointer');
      }
    });
  }

  private highlightRouteFromStop(routeId: string) {
    Object.entries(this.routeLayers).forEach(([id, r]) => {
      if (!r.routeLine) return;
      if (id === routeId) {
        r.routeLine.setStyle({ weight: 6, opacity: 1 });
      } else if (id !== this.activeRoute) {
        r.routeLine.setStyle({ weight: 2, opacity: 0.15 });
      }
    });
  }

  private resetAllRoutesStyle() {
    Object.entries(this.routeLayers).forEach(([id, r]) => {
      if (!r.routeLine) return;
      if (id === this.activeRoute) {
        r.routeLine.setStyle({ weight: 8, opacity: 1 });
      } else {
        r.routeLine.setStyle({ weight: 4, opacity: 0.45 });
      }
    });
  }

  async focusRoute(routeId: string) {
    this.activeRoute = routeId;

    Object.entries(this.routeLayers).forEach(([id, r]) => {
      if (!r.routeLine) return;

      if (id === routeId) {
        r.routeLine.setStyle({ weight: 8, opacity: 1 });
        r.stopUnclustered.clearLayers();
        r.stopMarkers.forEach((m, idx) => {
          m.setIcon(this.createNumberedStopIcon(idx + 1));
          r.stopUnclustered.addLayer(m);
        });
        r.stopUnclustered.addTo(this.map);
        if (this.map.hasLayer(r.stopCluster)) this.map.removeLayer(r.stopCluster);
      } else {
        r.routeLine.setStyle({ weight: 3, opacity: 0.35 });
        if (this.map.hasLayer(r.stopUnclustered)) this.map.removeLayer(r.stopUnclustered);
        if (!this.map.hasLayer(r.stopCluster)) r.stopCluster.addTo(this.map);
      }
    });

    const bounds = this.routeLayers[routeId].routeLine!.getBounds();
    this.map.fitBounds(bounds, { padding: [50, 50] });

    const layer = this.routeLayers[routeId];
    if (!layer) return;

    const activeRouteData = this.routes.find(r => r.id === routeId);
    if (!activeRouteData) return;

    const routeData = await (await fetch(activeRouteData.url)).json();
    const stopFeatures = routeData.features.filter(f => f.geometry.type === 'Point');

    this.activeStops = stopFeatures.map((f, index) => ({
      name: f.properties?.name || `Stop ${index + 1}`,
      coordinates: f.geometry.coordinates
    }));

  }

  focusStop(stop: any) {
    this.currentStop = stop;
    if (!stop?.coordinates) return;

    this.closeStopModal();
    const [lng, lat] = stop.coordinates;
    const latlng = L.latLng(lat, lng);
    this.map.setView(latlng, 16, { animate: true });
    this.showStopModal(latlng, stop.name);
  }


  private createDefaultStopIcon() {
    return L.divIcon({
      html: '<div class="custom-stop-base custom-stop-default"><i class="fa-solid fa-bus-simple"></i></div>',
      iconSize: [26, 26]
    });
  }

  private createNumberedStopIcon(num: number) {
    return L.divIcon({
      html: `<div class="custom-stop-base custom-stop-numbered">${num}</div>`,
      iconSize: [26, 26]
    });
  }

  openModal(title: string, contentHTML: string) {
    const modal = document.getElementById('modal')!;
    document.getElementById('modal-title')!.innerText = title;
    document.getElementById('modal-desc')!.innerHTML = contentHTML;
    modal.style.display = 'flex';
    setTimeout(() => modal.classList.add('active'), 10);
  }

  closeModal() {
    const modal = document.getElementById('modal')!;
    modal.classList.remove('active');
    setTimeout(() => (modal.style.display = 'none'), 300);
  }

  toggleRoute(route: any): void {
    route.checked = !route.checked;
    if (route.checked) {
      route.layer?.addTo(this.map);
    } else {
      this.map.removeLayer(route.layer);
    }
  }

  private onBusClick(bus): void {
    this.modalService.showBusDetails(bus);
  }

  private showStopModal(latlng: L.LatLng, name: string) {
    this.activeStop = { name, lat: latlng.lat, lng: latlng.lng };

    setTimeout(() => {
      const modalEl = document.getElementById('stop-modal');
      const mapContainer = document.getElementById('map');
      if (!modalEl || !mapContainer) return;
      let backdrop = document.getElementById('stop-modal-backdrop');
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.id = 'stop-modal-backdrop';
        backdrop.style.position = 'absolute';
        backdrop.style.top = '0';
        backdrop.style.left = '0';
        backdrop.style.width = '100%';
        backdrop.style.height = '100%';
        backdrop.style.zIndex = '999';
        backdrop.style.background = 'transparent';
        mapContainer.appendChild(backdrop);
        backdrop.addEventListener('click', () => this.closeStopModal());
      }

      modalEl.innerHTML = `
        <div class="stop-modal-container">
          <div id="close-icon" class="close-icon d-flex justify-content-center align-items-center pointer">
            <i class="fa fa-times"></i>
          </div>
          <h5>${name}</h5>
          <p>${latlng.lat.toFixed(4)}, ${latlng.lng.toFixed(4)}</p>
        </div>
      `;

      const btn = document.getElementById('close-icon');
      if (btn) btn.addEventListener('click', () => this.closeStopModal());

      const point = this.map.latLngToContainerPoint(latlng);
      const offsetX = 0;
      const offsetY = -60;
      modalEl.style.left = `${point.x + offsetX}px`;
      modalEl.style.top = `${point.y + offsetY}px`;

      modalEl.style.display = 'block';
      modalEl.classList.add('active');
    }, 0);

    const stop = {
      name: name,
      latLng: [latlng.lat, latlng.lng]
    }
    this.focusStop(stop)
  }

  closeStopModal() {
    const modalEl = document.getElementById('stop-modal');
    const backdrop = document.getElementById('stop-modal-backdrop');
    if (modalEl) {
      modalEl.classList.remove('active');
      modalEl.style.display = 'none';
    }
    if (backdrop) backdrop.remove();
    this.activeStop = null;
  }

  get firstLastStops() {
    const firstStop = this.activeStops[0];
    const lastStop = this.activeStops[this.activeStops?.length - 1];
    const routeStops = {
      firstStop: firstStop,
      lastStop: lastStop
    }
    return routeStops;
  }

  resetActiveRouteStops() {
    this.activeRoute = null;
    this.activeStops = [];
    this.closeStopModal();

    Object.values(this.routeLayers).forEach(r => {
      if (!r.routeLine) return;

      r.routeLine.setStyle({ weight: 4, opacity: 0.45 });

      if (this.map.hasLayer(r.stopUnclustered)) {
        this.map.removeLayer(r.stopUnclustered);
      }

      if (!this.map.hasLayer(r.stopCluster)) {
        r.stopCluster.addTo(this.map);
      }
    });

    const allBounds = L.latLngBounds([]);
    Object.values(this.routeLayers).forEach(r => {
      if (r.routeLine) allBounds.extend(r.routeLine.getBounds());
    });
    if (allBounds.isValid()) {
      this.map.fitBounds(allBounds, { padding: [50, 50] });
    }
  }

}
